/* ============================================================================
   mk-product-labels — etiket katmanının doğru konumlanması için yardımcı.
   Etiketler position:absolute; bu yüzden en yakın üst kapsayıcının
   position:relative olması gerekir. Tema kapsayıcısı "static" ise burada
   relative'e çekilir. jQuery YOK, global değişken YOK (IIFE).
   ============================================================================ */
(function () {
  'use strict';

  function anchorLayers(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var layers = scope.querySelectorAll('.mk-label-layer');
    for (var i = 0; i < layers.length; i++) {
      var parent = layers[i].parentElement;
      if (!parent || parent.dataset.mkAnchored === '1') continue;
      var pos = window.getComputedStyle(parent).position;
      if (pos === 'static') {
        parent.style.position = 'relative';
      }
      parent.dataset.mkAnchored = '1';
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { anchorLayers(document); });
  } else {
    anchorLayers(document);
  }

  // Tema editöründe bölüm yeniden yüklendiğinde de çalışsın
  document.addEventListener('shopify:section:load', function (e) {
    anchorLayers(e.target || document);
  });
})();
